export const API_KEY_WEATHER = "4385fe1353574335bc6142923230506";
export let RADIUS = 300; // metres
export let MAPZOOM = 16;
